import { render, staticRenderFns } from "./h5VideoLive.vue?vue&type=template&id=305031b8&scoped=true"
import script from "./h5VideoLive.vue?vue&type=script&lang=js"
export * from "./h5VideoLive.vue?vue&type=script&lang=js"
import style0 from "./h5VideoLive.vue?vue&type=style&index=0&id=305031b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305031b8",
  null
  
)

export default component.exports